import { AdSenseExperiment } from '@/modules/adv/providers/google-ad-sense-ad-provider/AdSenseExperiment'
import { loadScript } from '@/utils/loadScript'

import {
    AdSenseAdBreakFunctionForH5Game,
    AdSenseAdBreakFunctionParam,
    AdSenseAdConfigFunctionForH5Game,
    AdSenseAdConfigFunctionParam,
} from './AdSenseAdBreak'
import { AdSenseWindow } from './AdSenseWindow'
import { AD_BREAK_MAXIMUM_FREQUENCY_RATE, AD_SENSE_CLIENT_ID } from './constants'

export type AdSenseScriptFunctions = {
    adBreak: AdSenseAdBreakFunctionForH5Game
    adConfig: AdSenseAdConfigFunctionForH5Game
}

const AS_SENSE_LOAD_SCRIPT_TIMEOUT_MS = 3_000

export type LoadAdSenseScriptOptions = {
    exp?: AdSenseExperiment
}

/**
 * https://adsense.google.com/adsense/u/0/pub-2864899775153797/reporting/?rt=q&ag=channel&gm=earnings&m=earnings%2CmonetizableImpressions%2CmonetizableImpressionsRpm%2CactiveViewViewability%2Cclicks&oc=earnings&oo=descending&ct=b&ol=custom_channels
 */
const AD_SENSE_CHANNEL_IDS: Record<AdSenseExperiment, string> = {
    group_control: '5883774659',
    group_1: '1903332893',
    // group_2: '1564180293',
    // group_3: '4570692980',
}

export function loadAdSenseScript({ exp }: LoadAdSenseScriptOptions): Promise<AdSenseScriptFunctions> {
    const loadScriptPromise = loadScript({
        src: `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js`,
        timeoutMs: AS_SENSE_LOAD_SCRIPT_TIMEOUT_MS,
        onBeforeFirstLoad: (script) => {
            script.crossOrigin = 'anonymous'

            script.setAttribute('data-ad-client', AD_SENSE_CLIENT_ID)
            script.setAttribute('data-ad-frequency-hint', AD_BREAK_MAXIMUM_FREQUENCY_RATE)

            if (exp) {
                script.setAttribute('data-ad-channel', AD_SENSE_CHANNEL_IDS[exp])
            }

            script.async = true
        },
    })

    return loadScriptPromise.then(() => {
        const { adsbygoogle } = document.defaultView as AdSenseWindow

        if (!adsbygoogle) {
            throw new Error('adsbygoogle is not defined')
        }

        return {
            adBreak: (o: AdSenseAdBreakFunctionParam) => {
                adsbygoogle.push(o)
            },
            adConfig: (o: AdSenseAdConfigFunctionParam) => {
                adsbygoogle.push(o)
            },
        }
    })
}
